import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[climbDropdownItem]',
})
export class DropdownItemDirective {
    @HostBinding('role') role = 'menuitem';
}
